module.exports = __webpack_public_path__ + "img/tubiao-45.fcff72ea.png";